export default __webpack_public_path__ + "static/media/fastener-placement-square-trapezoid.e6e1a5be.webp";